import { useTheme } from 'styled-components';
import Column from '../core/components/box/column';
import SizedBox from '../core/components/box/sizedBox';
import { XCenter } from '../core/components/center';
import { LXh2 } from '../core/texts/lxText';
import { List, Skeleton } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useEffect } from 'react';
import Divider from './components/divider';
import useNotificationController from '../../1_application/notification/notificationController';
import Item from './components/item';
import BoxContainer from '../core/components/box/boxContainer';

const NotificationPage = () => {
  const theme = useTheme();

  const { data, moreDate, loading, today, isEndOfData, readNotification } =
    useNotificationController();

  useEffect(() => {
    moreDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <XCenter>
      <Column>
        <SizedBox height={80} />
        <LXh2>{theme.texts.notification}</LXh2>
        <SizedBox height={40}></SizedBox>
        <BoxContainer>
          <InfiniteScroll
            dataLength={data.length}
            next={moreDate}
            hasMore={!isEndOfData}
            loader={<Skeleton avatar paragraph={{ rows: 1 }} active />}
          >
            <List
              loading={loading}
              style={{ padding: '30px' }}
              dataSource={data}
              renderItem={(item, idx) => (
                <Column key={item.id}>
                  <Divider
                    base={data[idx - 1]?.createdAt}
                    today={today.current}
                    item={item}
                  ></Divider>
                  <Item
                    onClick={readNotification(item.id)}
                    item={item}
                    today={today.current}
                  ></Item>
                </Column>
              )}
            ></List>
          </InfiniteScroll>
        </BoxContainer>
      </Column>
    </XCenter>
  );
};

export default NotificationPage;
